<template>
    <div class="my-10">
        <div class="flex flex-col">
            <h1 class="font-bold text-2xl">{{ $t('nav.payments') }}</h1>
            <div class="mx-auto min-w-96 flex flex-col gap-5">
                <div class="flex flex-col gap-5">
                    <PaymentCard @onRemove="removePayment" v-for="pay in payments" :key="pay.id" :detail="pay">

                    </PaymentCard>
                </div>
                <div v-show="loading === true" class="flex justify-center mx-auto w-full" role="status">
                    <IconSpinner class="w-12 h-12 mr-2 text-gray-200 animate-spin  fill-main-color">
                    </IconSpinner>

                    <span class="sr-only">Loading...</span>
                </div>
            </div>
            <div class="mt-5" v-show="payments.length === 0 && loading === false">
                <p class="text-xl font-medium whitespace-nowrap">{{ $t('page.no_payments') }}</p>
            </div>


        </div>

    </div>
</template>
<script>
import api from '@/api';
import PaymentCard from "@cmp/PaymentCard.vue";
import { i18n } from '@/i18n'

export default {
    name: '',
    components: {
        PaymentCard

    },
    data() {
        return {
            loading: false,
            payments: []
        }
    },
    methods: {
        async getPayments() {
            this.loading = true
            try {
                const response = await api.get('payments/payments/')
                this.payments = response.data.results
            } catch (e) {
                console.log(e)
            }
            this.loading = false

        },
        async removePayment(id){
            this.loading = true

            try {
                const response = await api.delete(`payments/payments/${id}/`)
                await this.getPayments()
                this.$toast.info(i18n.global.t('warning.PAYMENT_DELETED'))
            }catch (e){
                console.log(e)
            }
            this.loading = false

        }
    },
    computed: {},
    created() {
        this.getPayments()
    }
}

</script>